export default __webpack_public_path__ + "1da5421340f688db86c607c3e0fbc1b3.png";